import React from 'react';
import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';
const OptionMessage = (props) => {
    let { messageId, values, optionValue } = props;
    let { t } = useTranslation();
    return React.createElement("option", { value: optionValue }, t(messageId, values));
};
OptionMessage.propTypes = {
    messageId: PropTypes.string.isRequired,
    optionValue: PropTypes.any.isRequired,
    values: PropTypes.object,
};
export default OptionMessage;
